import Vue from 'vue'
Vue.config.productionTip = false

import Application from '@/Application'

import './plugins'
import './classes'
import './mixins'
import './components'

;(function () {
    this.CreateApplication = function (config) {
        return new Application(config)
    }
}.call(window))
